/**
 * Unity Types File Renderer
 * Generates TypeElement class and static Types class with all type data
 */

/**
 * Render types file for Unity C# exports
 * Generates TypeElement class and static Types class with all type data
 * 
 * @param types - Array of type groups with data
 * @param namespace - C# namespace (default: 'Grimoire.Data')
 * @param className - Class name for the static types class (default: 'Types')
 */
export function renderTypesFile(
  types: any[],
  namespace: string = 'Grimoire.Data',
  className: string = 'Types'
): string {
  console.log(`🔷 Rendering types file for namespace: ${namespace}`);
  console.log(`📊 Processing ${types.length} type groups`);
  
  let output = '// Auto-generated Types\n';
  output += '// This file is AUTO-GENERATED and can be safely regenerated.\n';
  output += '// DO NOT EDIT THIS FILE DIRECTLY - your changes will be lost.\n\n';
  output += `namespace ${namespace}\n{\n`;
  
  // Generate TypeElement class
  output += '\tpublic sealed class TypeElement\n\t{\n';
  output += '\t\tpublic string Id;\n';
  output += '\t\tpublic string Name;\n';
  output += '\t\tpublic string Code;\n';
  output += '\t\tpublic string Value;\n';
  output += '\t}\n\n';
  
  // Generate Types static class
  output += `\tpublic static class ${className}\n\t{\n`;
  
  // Process each type group
  types.forEach((typeGroup, groupIndex) => {
    if (!typeGroup.data || !Array.isArray(typeGroup.data) || typeGroup.data.length === 0) {
      return;
    }
    
    // Get type group name (sanitize for C# class name)
    const typeGroupName = (typeGroup.name || `Group${groupIndex}`)
      .replace(/[^a-zA-Z0-9_]/g, '_');
    
    console.log(`  📦 Processing type group: ${typeGroupName} (${typeGroup.data.length} elements)`);
    
    output += `\t\tpublic static class ${typeGroupName}\n\t\t{\n`;
    
    // Process each type element in the group
    typeGroup.data.forEach((element: any) => {
      const elementName = (element.name || element.id || 'Unknown')
        .replace(/[^a-zA-Z0-9_]/g, '_');
      
      const elementId = element.id || '';
      const elementCode = element.code || element.name || '';
      const elementValue = element.value || '';
      
      // Escape strings for C#
      const escapedId = elementId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedName = (element.name || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedCode = elementCode.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedValue = elementValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      
      output += `\t\t\tpublic static readonly TypeElement ${elementName} = new()\n\t\t\t{\n`;
      output += `\t\t\t\tId = "${escapedId}",\n`;
      output += `\t\t\t\tName = "${escapedName}",\n`;
      output += `\t\t\t\tCode = "${escapedCode}",\n`;
      output += `\t\t\t\tValue = "${escapedValue}"\n`;
      output += '\t\t\t};\n\n';
    });
    
    output += '\t\t}\n\n';
  });
  
  output += '\t}\n';
  output += '}\n';
  
  console.log('✅ Types file rendered successfully');
  
  return output;
}
